import { tokenAxios } from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";
import { TaoDepartmentsArgs, TaoDepartmentsResponse } from "@/types/tao-routing";
import { useAppState } from "@/contexts/app-state";
import { buildApiUrl } from "@/utils/api";

const getTaoDepartments = async (params: TaoDepartmentsArgs) => {
  // @eslint-disable-line
  const { data } = await tokenAxios().get<TaoDepartmentsResponse>(buildApiUrl("taoDepartments"), { params });
  return data;
};

export const useTaoDepartments = () => {
  const { context, loggedInUser } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const requestedUser = loggedInUser;

  return useQuery<TaoDepartmentsResponse, Error>({
    queryKey: ["Tao-Routing-Departments", practiceId, requestedUser],
    queryFn: () => getTaoDepartments({ practiceId, requestedUser }),
  });
};
